import { SVGInterface } from "../../interface";

const Calculator = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 2.94116C4.90455 2.94116 4 3.84571 4 4.94116V20.9412C4 22.0366 4.90455 22.9412 6 22.9412H18C19.0955 22.9412 20 22.0366 20 20.9412V4.94116C20 3.8481 19.0931 2.94116 18 2.94116H6ZM6 4.94116H18V20.9412H6V4.94116ZM8 6.94116V9.94116H16V6.94116H8ZM8 12.9412V14.9412H12V12.9412H8ZM14 12.9412V14.9412H16V12.9412H14ZM8 16.9412V18.9412H11V16.9412H8ZM14 16.9412V18.9412H16V16.9412H14Z"
      fill={color || "#0E171F"}
    />
  </svg>
);
export default Calculator;
